import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfeatures2postPostFeaturesAppFeatureKeyDecisionResponseSchema = jsonObject
export type tcpfeatures2postPostFeaturesAppFeatureKeyDecisionResponse = z.infer<typeof tcpfeatures2postPostFeaturesAppFeatureKeyDecisionResponseSchema>
export const tcpfeatures2postPostFeaturesAppFeatureKeyPanelDecisionResponseSchema = jsonObject
export type tcpfeatures2postPostFeaturesAppFeatureKeyPanelDecisionResponse = z.infer<typeof tcpfeatures2postPostFeaturesAppFeatureKeyPanelDecisionResponseSchema>
